import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useAppliedJobsFilter } from './useAppliedJobsFilter';

export const AppliedJobsFilter = ({ value, setFilters }) => {
  const { formSchema, defaultOptions, isLoading, onSearchChange, onSubmit, onMenuOpen } = useAppliedJobsFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ jobApplicationsJobs: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="jobApplicationsJobs"
          label="Applied jobs"
          placeholder="Search to add"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          defaultOptions={defaultOptions}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

AppliedJobsFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

AppliedJobsFilter.defaultProps = {
  value: [],
};
